
/**
 * Base class for data locators.
 *
 */
export abstract class BaseComponentLocator {
  assignable_param: string;
  public abstract toString(): string;
  public getParam(): string {
    return this.assignable_param;
  }
}


